import Link from "next/link";
import classes from "./header.module.css";
import Image from "next/image";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const MENU = [
  { label: (t: any) => t?.menu.about.title, href: "/gioi-thieu" },
  {
    label: (t: any) => t?.menu.products.title,
    href: "/san-pham",
    children: [
      {
        label: (t: any) => t?.menu.products.tea,
        href: "/san-pham/tra",
        image: "/images/tra.png",
      },
      {
        label: (t: any) => t?.menu.products.coffee,
        href: "/san-pham/ca-phe",
        image: "/images/cafe.png",
      },
      {
        label: (t: any) => t?.menu.products.agricultural,
        href: "/san-pham/nong-san",
        image: "/images/tieu.png",
      },
      // {
      //   label: (t: any) => t?.menu.products.drink,
      //   href: "/san-pham/nuoc-giai-khat",
      //   image: "/images/nuoc-gk.png",
      // },
      // {
      //   label: (t: any) => t?.menu.products.oil,
      //   href: "/san-pham/dau-an",
      //   image: "/images/dau-an.png",
      // },
    ],
  },
  { label: (t: any) => t?.menu.noidia.title, href: "/noi-dia" },
  { label: (t: any) => t?.menu.xuatkhau.title, href: "/xuat-khau" },
  {
    label: (t: any) => t?.menu.news.title,
    href: "/tin-tuc",
    children: [
      { label: (t: any) => t?.menu.news.newsTea, href: "/tin-tuc/tra" },
      { label: (t: any) => t?.menu.news.newsCoffee, href: "/tin-tuc/ca-phe" },
      { label: (t: any) => t?.menu.news.newsAgri, href: "/tin-tuc/nong-san" },
      { label: (t: any) => t?.menu.recruitment.title, href: "/tuyen-dung" },
    ],
  },
  { label: (t: any) => t?.menu.contact.title, href: "/lien-he" },
];

type ChildType = { label: (t: any) => string; href: string; image?: string };

const getLocalizedHref = (href: string, locale: string) => {
  if (!href || href === "#") return "#";
  if (href.startsWith("http://") || href.startsWith("https://")) return href;
  const cleanHref = href.startsWith("/") ? href : `/${href}`;
  if (cleanHref.startsWith(`/${locale}/`) || cleanHref === `/${locale}`) {
    return cleanHref;
  }
  return `/${locale}${cleanHref}`;
};

export function HeaderMenuItem({
  item,
  trans,
  locale = "vi",
}: {
  item: any;
  trans: any;
  locale?: string;
}) {
  const hasChildren = Boolean(item.children?.length);
  const isMega = item.href === "/san-pham" && hasChildren;
  const [open, setOpen] = useState(false);

  return (
    <div
      className={classes.menuItemWrapper}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{
        position: isMega ? "static" : "relative",
        display: "inline-block",
      }}
    >
      <span className={classes.menuItem}>
        <Link href={getLocalizedHref(item.href || "#", locale)} className={classes.menuLink}>
          {item.label(trans)}
        </Link>
      </span>

      {/* Chỉ render dropdown khi có children */}
      <AnimatePresence>
        {open && hasChildren && (
          <motion.div
            initial={{
              opacity: 0,
              y: 15,
              x: isMega ? "-50%" : 0,
            }}
            animate={{
              opacity: 1,
              y: 0,
              x: isMega ? "-50%" : 0,
            }}
            exit={{
              opacity: 0,
              y: 10,
              x: isMega ? "-50%" : 0,
            }}
            transition={{ duration: 0.25, ease: [0.23, 1, 0.32, 1] }}
            className={isMega ? classes.productDropdown : classes.dropdownMenu}
            style={{
              position: "absolute",
              zIndex: 100,
              ...(isMega
                ? { left: "50%", top: "100px" }
                : { left: 0, top: "100%" }),
            }}
          >
            {isMega ? (
              <>
                <div className={classes.productDropdownContent}>
                  <div className={classes.productGrid}>
                    {item.children.map((child: ChildType) => (
                      <Link key={child.href} href={getLocalizedHref(child.href, locale)}>
                        <div className={classes.productContent}>
                          <div className={classes.imageWrapper}>
                            <Image
                              src={child.image || ""}
                              alt={child.label(trans)}
                              width={120}
                              height={120}
                              className={classes.productImage}
                              quality={90}
                            />
                          </div>
                          <span className={classes.productLabel}>
                            {child.label(trans)}
                          </span>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
                <div className={classes.decoWrapper}>
                  <Image
                    src="/images/tea_deco_3.png"
                    alt="decoration"
                    width={160}
                    height={160}
                  />
                </div>
              </>
            ) : (
              item.children?.map((child: ChildType) => (
                <div key={child.href}>
                  <Link href={getLocalizedHref(child.href, locale)} className={classes.dropdownItem}>
                    {child.label(trans)}
                  </Link>
                </div>
              ))
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
